/* eslint-disable max-classes-per-file */
export class SeoSchemaResponse {
  status: number;

  statusCode: string;

  message: string;

  data: {
    th: any[];
    en: any[];
    metaTitle: {
      th: string;
      en: string;
    };
    metaDescription: {
      th: string;
      en: string;
    };
  };

  constructor(response: Partial<SeoSchemaResponse>) {
    this.status = response.status ?? 0;
    this.statusCode = response.statusCode ?? "";
    this.message = response.message ?? "";
    this.data = response.data ?? {
      th: [],
      en: [],
      metaTitle: { th: "", en: "" },
      metaDescription: { th: "", en: "" },
    };
  }
}

export class GetPromotionDetailSEOPagePersenter {
  status: boolean;

  statusCode: string;

  message: string;

  data:
    | {
        fullImage: string;
        thumbImage: string;
        mobileImage: string;
        homeImage: string;
        seo: {
          title: string;
          description: string;
          metaTitle: string;
          metaDescription: string;
        };
      }
    | undefined;

  constructor(response: any) {
    this.status = response.status ?? false;
    this.statusCode = response.statusCode ?? "";
    this.message = response.message ?? "";
    this.data = response.data
      ? {
          fullImage: response.data.fullImage ?? response.data.fullimage ?? "",
          thumbImage:
            response.data.thumbImage ?? response.data.thumbimage ?? "",
          mobileImage:
            response.data.mobileImage ?? response.data.mobileimage ?? "",
          homeImage: response.data.homeImage ?? response.data.homeimage ?? "",
          seo: {
            title: response.data.seo.title ?? "",
            description: response.data.seo.description ?? "",
            metaTitle: response.data.seo.metaTitle ?? "",
            metaDescription: response.data.seo.metaDescription ?? "",
          },
        }
      : undefined;
  }
}
